var _path, _path2, _g, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReportPaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.797 512V52.068h364.475v433.898c0 14.379-11.654 26.034-26.034 26.034H99.797z",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.237 138.847c-16.775 0-30.373-13.598-30.373-30.373V78.102h17.356v30.373c0 7.185 5.832 13.017 13.017 13.017s13.017-5.832 13.017-13.017V43.39c0-14.379-11.655-26.034-26.034-26.034s-26.034 11.655-26.034 26.034v8.678H125.83V43.39C125.83 19.43 145.26 0 169.22 0s43.39 19.43 43.39 43.39v65.085c0 16.774-13.598 30.372-30.373 30.372z",
    fill: "#754c24"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.034 338.441h147.525v17.356H282.034v-17.356zM282.034 373.153h147.525v17.356H282.034v-17.356zM282.034 407.864h112.814v17.356H282.034v-17.356zM342.78 303.729h86.78v17.356h-86.78v-17.356z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 360.136,
    cy: 182.237,
    r: 60.746,
    fill: "#fbb03b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.508 182.237h17.356v69.424h-17.356v-69.424z",
    fill: "#29abe2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169.22 199.593h17.356v52.068H169.22v-52.068z",
    fill: "#fbb03b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.932 164.881h17.356v86.78h-17.356v-86.78z",
    fill: "#29abe2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M238.644 190.915H256v60.746h-17.356v-60.746z",
    fill: "#fbb03b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.186 312.407h104.136v104.136H143.186V312.407z",
    fill: "#29abe2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M308.068 303.729h17.356v17.356h-17.356v-17.356z",
    fill: "#999"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M414.425 155.093a60.737 60.737 0 00-54.289-33.601v60.746l54.289-27.145z",
    fill: "#da4836"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#0071bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.136 121.492c-33.549 0-60.746 27.197-60.754 60.737a60.734 60.734 0 0017.798 42.965l42.956-42.956v-60.746zM438.237 512c-14.379 0-26.034-11.654-26.034-26.034V468.61H47.729v17.356c0 14.379 11.655 26.034 26.034 26.034h364.474z"
  }))));
}

export default __webpack_public_path__ + "8252461f5fc46ff67b8f1ea91c9cf854.svg";
export { SvgReportPaper as ReactComponent };